// extracted by mini-css-extract-plugin
export default {"navigationButton":"l3j2d4KOZva_Q5lqwpRD"};